// verifyPasswordToken
import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { AuthService } from '../../services';
import {
  types as actions,
  verifyPasswordTokenCompletedAction,
  errorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.VERIFY_PASSWORD_TOKEN),
    switchMap(action =>
      AuthService.verifyPasswordToken(action.email, action.token).pipe(
        map((data) => verifyPasswordTokenCompletedAction(data.response)),
        catchError(error => of(errorAction(error)))
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/auth/verifyPasswordToken.js